import { SettingOutlined } from "@ant-design/icons";
import * as React from "react";
import {
  columnDisplayId,
  sysColumnsHistory,
} from "src/business/sysData/sysColumns";
import { getWorkflowDisplayName } from "src/business/workflow/getWorkflowDisplayName";
import { makeMdmActionColumn, RenderLinkAction } from "src/components/MdmTable";
import { RtColumn } from "src/components/ReactiveTable/RtColumn";
import { makeUrl } from "src/routes/makeUrl";
import { PageUrl } from "src/routes/PageUrl";

import { workflowDestinations } from "../../../business/workflow/ZWorkflow";
import { ZWorkflowStream } from "../../../business/workflow/ZWorkflowStream";

export const createWorkflowStreamColumns = (
  showActions: boolean,
): RtColumn<ZWorkflowStream>[] => [
  columnDisplayId,
  {
    key: "displayName",
    title: "Название рабочего потока",
    render: (row) => getWorkflowDisplayName(row),
    minWidth: 200,
  },
  {
    key: "description",
    title: "Описание",
    render: ({ description }) => description,
    minWidth: 200,
  },
  {
    key: "catalog",
    title: "Каталог",
    render: ({ catalog }) => catalog?.label,
    minWidth: 140,
  },
  {
    key: "owner",
    title: "Владелец",
    render: ({ owner }) => owner?.label,
    minWidth: 140,
  },
  {
    key: "destination",
    title: "Назначение потока",
    render: ({ destination }) =>
      destination ? workflowDestinations[destination] : undefined,
    minWidth: 160,
  },
  ...sysColumnsHistory,
  ...(showActions
    ? [
        makeMdmActionColumn<ZWorkflowStream>({
          key: "settings",
          render: ({ id }) => (
            <RenderLinkAction
              icon={<SettingOutlined />}
              tooltip="Открыть настройки в новой вкладке"
              href={makeUrl(PageUrl.managementWorkflowCard, { id })}
            />
          ),
        }),
      ]
    : []),
];
